module.exports = __webpack_public_path__ + "img/Feature.0b42cd4b.png";